// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2e5c9929","453":"36597bf2"}[chunkId] + ".chunk.js";
};